import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

// Receive onLoginSuccess as a prop
function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [banner, setBanner] = useState({ show: false, message: '' });
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/login`,
        { username, password }
      );
      const { token, userId } = response.data;

      localStorage.setItem('token', token);
      localStorage.setItem('userId', userId);

      setUsername('');
      setPassword('');

      onLoginSuccess();
      navigate('/'); // Redirect to home page

    } catch (error) {
      setBanner({
        show: true,
        message: error.response?.data?.error || 'Error logging in'
      });
    }
  };

  const closeBanner = () => setBanner({ ...banner, show: false });

  return (
    <div className="login-container">
      {banner.show && (
        <div
          style={{
            background: "#f44336",
            color: "#fff",
            padding: "1em",
            borderRadius: "5px",
            marginBottom: "1em",
            position: "relative",
            textAlign: "center"
          }}
        >
          {banner.message}
          <button
            onClick={closeBanner}
            style={{
              position: "absolute",
              right: 10,
              top: 10,
              background: "transparent",
              border: "none",
              color: "#fff",
              fontSize: "1.2em",
              cursor: "pointer"
            }}
            aria-label="Close"
          >
            ×
          </button>
        </div>
      )}
      <h2>Welcome Back,</h2>
      <form className="login-form" onSubmit={handleLogin}>
        <div className="form-group">
          <label htmlFor="username">Username:</label>
          <input type="text" id="username" value={username} onChange={(e) => setUsername(e.target.value)} />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <a className="password-reset" href="/forgot-password">Forgot your Password?</a>
        <button className="submit-button" type="submit">Login</button>
      </form>
      <div className="message-container">
        <p className="message">Don't have an account? <a href="./register">Register here</a></p>
        <hr></hr>
      </div>
    </div>
  );
}

export default Login;

